import { apiClient } from "infra/api-client"
import { BASE_URL } from "global"

class LllService {

  async createProviderToken(options: {
    user_type: string,
    user_key: string,
    scope: string[]
  }) {

    const response = await apiClient.post(BASE_URL + "lll/createProviderToken", {
      user_type: options.user_type,
      user_key: options.user_key,
      scope: options.scope,
    });

    return response.data;

  }

}

export const lllService = new LllService();



